module.exports = __webpack_public_path__ + "static/media/logo_fond_blanc.0aae797e.png";